import React from 'react';

export const CaledarIcon = () => (
  <svg
    className="calendar-icon"
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.625 4.313h-3.938v-1.5a.188.188 0 0 0-.187-.188h-1.313a.188.188 0 0 0-.187.188v1.5H9v-1.5a.188.188 0 0 0-.188-.188H7.5a.188.188 0 0 0-.188.188v1.5H3.376a.75.75 0 0 0-.75.75v15.562c0 .415.335.75.75.75h17.25a.75.75 0 0 0 .75-.75V5.062a.75.75 0 0 0-.75-.75Zm-.938 15.375H4.313V10.78h15.375v8.906ZM4.313 9.188V6h3v1.125c0 .103.085.188.188.188h1.313A.188.188 0 0 0 9 7.125V6h6v1.125c0 .103.084.188.188.188H16.5a.188.188 0 0 0 .188-.188V6h3v3.188H4.313Z"
      fill="#000"
    />
  </svg>
);
